var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClassicViewQuiz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FA6625",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4 15h32v10H4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#748499",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M4 35h32M4 30h32M4 5h32M4 10h32"
  })));
}
export default __webpack_public_path__ + "fonts/classic-view-quiz-fc0f28650abd09d259a443a390abe8b2.svg";
export { SvgClassicViewQuiz as ReactComponent };